import type { NewsItem } from './types'

export function normalizeNewsLink(link: string): string {
  return link.trim().toLowerCase()
}

/** Última ocorrência vence (lista já ordenada por chegada não importa). */
export function dedupeNewsByLink(items: NewsItem[]): NewsItem[] {
  const m = new Map<string, NewsItem>()
  for (const it of items) {
    m.set(normalizeNewsLink(it.link), it)
  }
  return [...m.values()]
}

/** Mantém itens do snapshot; sobrescreve com itens buscados nesta rodada (mesmo link). */
export function mergeSnapshotPreferFetched(snapshot: NewsItem[], fetched: NewsItem[]): NewsItem[] {
  const m = new Map<string, NewsItem>()
  for (const it of snapshot) m.set(normalizeNewsLink(it.link), it)
  for (const it of fetched) m.set(normalizeNewsLink(it.link), it)
  return [...m.values()]
}

export function sortNewsByPubDate(items: NewsItem[]): NewsItem[] {
  return [...items].sort((a, b) => {
    const da = a.pubDate?.getTime() ?? 0
    const db = b.pubDate?.getTime() ?? 0
    return db - da
  })
}

/** Remove itens cujo feed não está mais habilitado (evita snapshot/cache “fixo” com todas as fontes). */
export function filterNewsByActiveSourceIds(
  news: NewsItem[],
  activeSourceIds: ReadonlySet<string>,
): NewsItem[] {
  return news.filter((n) => activeSourceIds.has(n.sourceId))
}
